import base64 from 'base-64';
import utf8 from 'utf8';
import { toast } from 'react-toastify';

var clearToken;

export function setApiClearTokenFunction(clearTokenFunction) {
    clearToken = clearTokenFunction;
}

function getToken() {
    return localStorage.getItem('token');
}

export function login(username, password) {
    return fetch(process.env.REACT_APP_API_URL + '/login', {
        headers: new Headers({
            "Authorization": `Basic ${base64.encode(utf8.encode(`${username}:${password}`))}`
        })
    }).then((response) => {
        if (!response.ok) {
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                response.json().then(data => {
                    toast.error(data.message);
                });
            } else {
                console.log(`api request failed [url=${response.url}, status=${response.status}] `);
            }
            throw new Error("error");
        } else {
            return response.json();
        }
    });
}

export function retrieveUser() {
    return request({ url: '/users/me', method: 'GET' });
}

export function retrieveAdminInfo() {
    return request({ url: '/adminInfo', method: 'GET' });
}

export function createUser(email, firstName, lastName, name, password, confirmPassword) {
    return request({
        url: '/users',
        method: 'POST',
        data: {
            email: email,
            first_name: firstName,
            last_name: lastName,
            name: name,
            password: password,
            confirmed_password: confirmPassword
        }
    });
}

export function requestPasswordReset(email) {
    return request({
        url: '/users/me/password',
        method: 'POST',
        data: {
            email: email,
        }
    });
}

export function resetPassword(password, confirmedPassword, resetToken) {
    return request({
        url: '/users/me/password',
        method: 'PUT',
        data: {
            password: password,
            confirmed_password: confirmedPassword
        },
        token: resetToken,
    });
}

export function createEntryApprovalRequest(year, entryAmount, overheadAmount, description) {
    return request({
        url: '/approvals',
        method: 'POST',
        data: {
            year: year,
            entry_amount: entryAmount,
            overhead_amount: overheadAmount,
            description: description
        }
    });
}

export function retrieveApprovalRequests() {
    return request({ url: '/approvals', method: 'GET' });
}

export function updateApprovalRequest(id, status) {
    return request({ url: '/approvals', method: 'PUT', data: {
        id: id,
        status: status
    }});
}

export function retrieveUsers() {
    return request({ url: '/users', method: 'GET' });
}

export function retrieveWeeks() {
    return request({ url: '/weeks', method: 'GET' });
}

export function retrieveGames(week, onlyAvailable) {
    let params = { week };
    if (onlyAvailable) {
        params.available = 'true';
    }
    return request({ url: '/games', method: 'GET', params });
}

export function reloadGames(week) {
    return request({ url: '/games', method: 'PUT', params: { week }});
}

export function setGameScore(game, homePoints, awayPoints) {
    return request({ url: '/game', method: 'PUT', data: {
        id: game.id,
        home_points: homePoints,
        away_points: awayPoints
    }});
}

export function setGameHomeSpread(game, homeSpread) {
    return request({ url: '/game', method: 'PUT', data: {
        id: game.id,
        home_spread: homeSpread
    }});
}

export function createEntry(week) {
    return request({ url: '/entries', method: 'POST', data: {
        week: week
    }});
}

export function retrieveMyEntries(week) {
    return request({url: '/entries/me', method: 'GET', params: { week }});
}

export function retrieveEntries(week) {
    return request({url: '/entries', method: 'GET', params: { week }});
}

export function addPickToEntry(home_team, game, entry) {
    return request({url: '/entries/picks', method: 'POST', data: {
        entry_id: entry.id,
        game_id: game.id,
        home_team: home_team
    }});
}

export function removePickFromEntry(game, entry) {
    return request({url: '/entries/picks', method: 'DELETE', data: {
        entry_id: entry.id,
        game_id: game.id
    }});
}

export function submitEntry(entry) {
    return request({ url: '/entries', method: 'PUT', data: {
        id: entry.id
    }});
}

let toastVisible = false;

function request({ url, method, data, params, token = getToken() }) {
    let headers = new Headers({
        'Content-Type': 'application/json'
    });

    if (token) {
        headers.append("Authorization", `bearer ${token}`);
    }

    const options = {
        method,
        headers,
        credentials: 'include',
        mode: 'cors'
    };
    if (data) {
        options.body = JSON.stringify(data);
    }
    //let urlObject = new URL(process.env.REACT_APP_API_URL + url);
    let urlObject = new URL(window.location.origin + '/api' + url);
    if (params) {
        Object.keys(params).forEach(key => urlObject.searchParams.append(key, params[key]));
    }
    return fetch(urlObject, options).then((response) => {
        if (response.status === 401) {
            if (!toastVisible) {
                toastVisible = true;
                toast.error("Login expired. Please login again.");
                setTimeout(() => toastVisible = false, 3000);
            }
            if (clearToken) {
                clearToken();
            }
            throw new Error('api call failed');
        }
        if (!response.ok) {
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                response.json().then(data => {
                    toast.error(data.message);
                });
            } else {
                console.log(`api request failed [url=${response.url}, status=${response.status}] `);
            }
            throw new Error('api call failed');
        } else {
            return response.json();
        }
    });
}
